module.exports = __webpack_public_path__ + "img/bg2.516600d6.jpg";